import { getSectionTpl } from './../model/tpl/stat';
import { isDefined, not, truthy, allOf, anyOf, parseInt10, parseStrIntToInt, each } from '../../../utils/util';
import StatModel from './StatModel';

class Section {
  constructor(options) {
    const _ = this;

    _.option = $.extend({
      wrap: null,
      model: null
    }, options);

    _.wrap = null;

    _.model = StatModel.getInstance();
  }

  init(obj = null) {
    const _ = this;

    _.wrap = $(_.option.wrap);

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    _.setUpDownBtns();

    _.activateAllMinusBtns(false);

    _.activateAllPlusBtns(false);
  }

  setUpDownBtns() {
    var _ = this,
      $_ = $(this);

    // plus btns
    $('.stat-STR button.up', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_PLUS_STAT, statName: 'STR'});
    });

    $('.stat-DEX button.up', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_PLUS_STAT, statName: 'DEX'});
    });

    $('.stat-INT button.up', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_PLUS_STAT, statName: 'INT'});
    });

    $('.stat-CON button.up', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_PLUS_STAT, statName: 'CON'});
    });

    $('.stat-WIS button.up', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_PLUS_STAT, statName: 'WIS'});
    });

    $('.stat-CHA button.up', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_PLUS_STAT, statName: 'CHA'});
    });

    // minus btns
    $('.stat-STR button.down', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_MINUS_STAT, statName: 'STR'});
    });

    $('.stat-DEX button.down', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_MINUS_STAT, statName: 'DEX'});
    });

    $('.stat-INT button.down', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_MINUS_STAT, statName: 'INT'});
    });

    $('.stat-CON button.down', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_MINUS_STAT, statName: 'CON'});
    });

    $('.stat-WIS button.down', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_MINUS_STAT, statName: 'WIS'});
    });

    $('.stat-CHA button.down', _.wrap).on('click', function (evt) {
      evt.preventDefault();
      $_.trigger({type: Section.EVT_MINUS_STAT, statName: 'CHA'});
    });
  }

  removeUpDownBtnsEventHandler() {
    const _ = this;

    $('.stat-STR button', _.wrap).off('click');
    $('.stat-DEX button', _.wrap).off('click');
    $('.stat-INT button', _.wrap).off('click');
    $('.stat-CON button', _.wrap).off('click');
    $('.stat-WIS button', _.wrap).off('click');
    $('.stat-CHA button', _.wrap).off('click');
  }

  setBtnUsable($btn, flag) {
    if (anyOf(not(isDefined)($btn), $btn.length < 0)) return;

    if (truthy(flag)) {
      $btn.attr('disabled', false).addClass('on');

    } else {
      $btn.attr('disabled', true).removeClass('on');
    }
  }

  activateAllMinusBtns(flag) {
    var _ = this,
      downBtns = $('button.down', _.wrap);

    for (var i = 0, max = downBtns.length; i < max; i++) {
      _.setBtnUsable($(downBtns.get(i)), flag);
    }
  };

  activateAllPlusBtns(flag) {
    var _ = this,
      upBtns = $('button.up', _.wrap);

    for (var i = 0, max = upBtns.length; i < max; i++) {
      _.setBtnUsable($(upBtns.get(i)), flag);
    }
  };

  activatePlusBtn(statName, flag) {
    var _ = this,
      btn = $('.' + statName + ' button.up', _.wrap);

    _.setBtnUsable(btn, flag);
  }

  activateMinusBtn(statName, flag) {
    var _ = this,
      btn = $('.' + statName + ' button.down', _.wrap);

    _.setBtnUsable(btn, flag);
  }

  setChangedStat(isCompleteSetBaseStat, changedStats, receivedStats, statsFirstAtLevel, baseStatsForHighlight = null) {
    const _ = this;

    console.log('changedStats :', changedStats);

    //set stats
    for (let key in changedStats) {
      if (not(isDefined)(changedStats[key])) continue;

      let statList = $(`.${key}`, _.wrap);
      if (statList.length > 0) {

        if (truthy(isCompleteSetBaseStat)) {
          (key === 'STR' || key === 'INT' || key === 'DEX' || key === 'WIS' || key === 'CON' || key === 'CHA') ? statList.addClass('on') : statList.addClass('em1').addClass('em2');

        } else {
          (key === 'STR' || key === 'INT' || key === 'DEX' || key === 'WIS' || key === 'CON' || key === 'CHA') ? statList.addClass('on') : statList.addClass('em1');
        }

        $(`.${key} var`, _.wrap).text(changedStats[key]);
      }
    }

    _.setChangedRangeField(isCompleteSetBaseStat, $('.LEVELUP_MP_PLUS', _.wrap), changedStats.LEVELUP_MP_PLUS_MIN, changedStats.LEVELUP_MP_PLUS_MAX, receivedStats.LEVELUP_MP_PLUS_MIN, receivedStats.LEVELUP_MP_PLUS_MAX);
    _.setChangedRangeField(isCompleteSetBaseStat, $('.HP_PLUS', _.wrap), changedStats.LEVELUP_HP_PLUS_MIN, changedStats.LEVELUP_HP_PLUS_MAX, receivedStats.LEVELUP_HP_PLUS_MIN, receivedStats.LEVELUP_HP_PLUS_MAX);
    _.setChangedRangeField(isCompleteSetBaseStat, $('.HP_RECOVER_TIC', _.wrap), changedStats.HP_RECOVER_TIC_MIN, changedStats.HP_RECOVER_TIC_MAX, receivedStats.HP_RECOVER_TIC_MIN, receivedStats.HP_RECOVER_TIC_MAX);

    // minus
    if (isDefined(statsFirstAtLevel)) {
      console.log('statsFirstAtLevel :', statsFirstAtLevel);

      let changedVal, statItem;
      for (let key in changedStats) {
        changedVal = changedStats[key];

        statItem = $(`.${key}`, _.wrap);

        if (anyOf(not(isDefined)(changedVal), statItem.length <= 0)) continue;

        if (truthy(isCompleteSetBaseStat)) {
          if (changedVal === statsFirstAtLevel[key]) statItem.removeClass('em2');

          if (isDefined(baseStatsForHighlight)) {
            if (changedVal === baseStatsForHighlight[key]) statItem.removeClass('on').removeClass('em1');
          }

        } else {
          if (changedVal === statsFirstAtLevel[key]) statItem.removeClass('on').removeClass('em1');
        }
      }

      // WIS
      _.setChangedRangeFieldCompareStatFirstAtLevel(isCompleteSetBaseStat, $('.LEVELUP_MP_PLUS', _.wrap), 'LEVELUP_MP_PLUS_MIN', 'LEVELUP_MP_PLUS_MAX', changedStats, receivedStats, statsFirstAtLevel, baseStatsForHighlight);

      // CON
      _.setChangedRangeFieldCompareStatFirstAtLevel(isCompleteSetBaseStat, $('.HP_PLUS', _.wrap), 'LEVELUP_HP_PLUS_MIN', 'LEVELUP_HP_PLUS_MAX', changedStats, receivedStats, statsFirstAtLevel, baseStatsForHighlight);
      _.setChangedRangeFieldCompareStatFirstAtLevel(isCompleteSetBaseStat, $('.HP_RECOVER_TIC', _.wrap), 'HP_RECOVER_TIC_MIN', 'HP_RECOVER_TIC_MAX', changedStats, receivedStats, statsFirstAtLevel, baseStatsForHighlight);
    }
  }

  setChangedRangeFieldCompareStatFirstAtLevel(isCompleteSetBaseStat, statItem, minValueName, maxValueName, changedStats, receivedStats, statsFirstAtLevel, baseStatsForHighlight = null) {
    if (anyOf(isDefined(changedStats[minValueName]), isDefined(changedStats[maxValueName]))) {
      const minVal = parseStrIntToInt(receivedStats[minValueName]),
        maxVal = parseStrIntToInt(receivedStats[maxValueName]);

      if (truthy(isCompleteSetBaseStat)) {
        if (allOf(minVal === parseStrIntToInt(statsFirstAtLevel[minValueName]), maxVal === parseStrIntToInt(statsFirstAtLevel[maxValueName]))) statItem.removeClass('em2');

        if (isDefined(baseStatsForHighlight)) {
          if (allOf(minVal === parseStrIntToInt(baseStatsForHighlight[minValueName]), maxVal === parseStrIntToInt(baseStatsForHighlight[maxValueName]))) statItem.removeClass('em1');
        }

      } else {
        if (allOf(minVal === parseStrIntToInt(statsFirstAtLevel[minValueName]), maxVal === parseStrIntToInt(statsFirstAtLevel[maxValueName]))) statItem.removeClass('em1');
      }
    }
  }

  setChangedRangeField(isCompleteSetBaseStat, statItem, changedMin, changedMax, receiveMin, receiveMax) {
    if (anyOf(isDefined(changedMin), isDefined(changedMax))) {
      if (statItem.length <= 0) return;

      (truthy(isCompleteSetBaseStat)) ? statItem.addClass('em1').addClass('em2') : statItem.addClass('em1');

      $('var', statItem).text(receiveMin + ' ~ ' + receiveMax);
    }
  }

  setStatValueColor(level) {
    const _ = this,
      stats = [$('.STR', _.wrap), $('.INT', _.wrap), $('.DEX', _.wrap), $('.WIS', _.wrap), $('.CON', _.wrap), $('.CHA', _.wrap)];

    // stat max value is 45, when level < 90
    // stat max value is 50, when level >= 90
    const statLevelColors = (level < _.model.LEVEL_CHANGE_STAT_MAX) ? _.model.STAT_LEVEL_COLORS : _.model.CHANGED_LEVEL_COLORS;

    let stat = null, point = 0;
    for (let i = 0, max = stats.length; i < max; i++) {
      stat = stats[i];
      point = parseInt10($('var', stat).text());

      each(statLevelColors, (colorObj) => {
        stat.removeClass(colorObj.class);
      });

      let colorClass = '';
      each(statLevelColors, (colorObj) => {
        if (colorObj.level <= point) {
          if (colorClass !== '') stat.removeClass(colorClass);

          colorClass = colorObj.class;
          stat.addClass(colorClass);
        }
      });
    }
  }

  // add '.on' class to changed stats
  setHighlightChangedStats(changedStats) {
    const _ = this;

    //set stats
    let statItem = null;
    for (let key in changedStats) {
      if (not(isDefined)(changedStats[key])) continue;

      statItem = $(`.${key}`, _.wrap);
      (key === 'STR' || key === 'INT' || key === 'DEX' || key === 'WIS' || key === 'CON' || key === 'CHA') ? statItem.addClass('on') : statItem.addClass('em1');
    }

    _.setHighlightRangedField($('.HP_PLUS', _.wrap), changedStats.LEVELUP_HP_PLUS_MIN, changedStats.LEVELUP_HP_PLUS_MAX);
    _.setHighlightRangedField($('.HP_RECOVER_TIC', _.wrap), changedStats.HP_RECOVER_TIC_MIN, changedStats.HP_RECOVER_TIC_MAX);
    _.setHighlightRangedField($('.LEVELUP_MP_PLUS', _.wrap), changedStats.LEVELUP_MP_PLUS_MIN, changedStats.LEVELUP_MP_PLUS_MAX);
  }

  setHighlightRangedField(statList, changedMinVal, changedMaxVal) {
    if (anyOf(isDefined(changedMinVal), isDefined(changedMaxVal))) {
      if (statList.length > 0) statList.addClass('em1');
    }
  }

  reset(stats) {
    const _ = this;

    _.removeUpDownBtnsEventHandler();

    const sectionTplFunc = doT.template(getSectionTpl());
    _.wrap.replaceWith(sectionTplFunc(stats));
    _.wrap = $('.variation.variation__stat');

    _.setUpDownBtns();
  }

  destroy(obj = null) {
    const _ = this;

    _.removeUpDownBtnsEventHandler();
  }
}

Section.EVT_PLUS_STAT = 'EVT_PLUS_STAT';
Section.EVT_MINUS_STAT = 'EVT_MINUS_STAT';

export default Section;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/stat/Section.js